import { collectPages } from '../shared/collectPages';
import type { ByPageOptions, SdkItems } from '../types';
import { iterateByPage } from './iterateByPage';

// gloss
export const fetchAllByPage = <R, T = SdkItems<R>>(options: ByPageOptions<R, T>): Promise<T[]> =>
  collectPages<T, ByPageOptions<R, T>>(iterateByPage<R, T>, options);
